module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('container', [_c('div', {
    staticClass: "info"
  }, [_c('router-link', {
    staticClass: "back-link",
    attrs: {
      "to": "/admin/past-run"
    }
  }, [_c('span', {
    staticClass: "back-arrow"
  }, [_vm._v("↩")]), _vm._v(" "), _c('span', {
    staticClass: "back-text"
  }, [_vm._v("Back")])]), _vm._v(" "), _c('span', {
    staticClass: "info-separator"
  }, [_vm._v("|")]), _vm._v(" "), _c('a', {
    staticClass: "live-run-link",
    attrs: {
      "href": _vm.liveRunUrl
    }
  }, [_c('svg', {
    staticClass: "live-icon",
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke": "currentColor",
      "stroke-width": "2",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.5 5.5L19 12L8.5 18.5V5.5Z",
      "fill": "currentColor"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("View Live Run")])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "large",
      "padding": "14px 10px 0px 0px"
    }
  }, [_vm._v("Recording:")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-width": "300px"
    }
  }, [(!_vm.isRecordingReady) ? _c('div', {
    staticStyle: {
      "padding": "14px 0",
      "color": "#666"
    }
  }, [_vm._v("\n          Preparing recording audio...\n        ")]) : _vm._e(), _vm._v(" "), (_vm.recordingUrl && _vm.isRecordingReady) ? _c('audio', {
    attrs: {
      "id": "my-audio",
      "controls": ""
    },
    on: {
      "ended": _vm.playEnd
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.recordingUrl,
      "type": "audio/mp3"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "race_desc"
  }, [_c('span', [_vm._v("Description")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "wrapper_description"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.race.description))])])]), _vm._v(" "), _c('div', {
    staticClass: "action-buttons-row"
  }, [_c('button', {
    staticClass: "refresh-btn",
    attrs: {
      "title": "Refresh data"
    },
    on: {
      "click": function($event) {
        return _vm.initialize()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 4V10H7",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23 20V14H17",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.49 9A9 9 0 0 0 5.64 5.64L1 10M23 14L18.36 18.36A9 9 0 0 1 3.51 15",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary load_data",
    attrs: {
      "id": "loaddatafb"
    },
    on: {
      "click": function($event) {
        return _vm.fromFireBase()
      }
    }
  }, [_vm._v("Load From Archive\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-dropdown"
  }, [_c('button', {
    staticClass: "menu-dots-btn",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "10",
      "cy": "5",
      "r": "1.5",
      "fill": "#999"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "10",
      "cy": "10",
      "r": "1.5",
      "fill": "#999"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "10",
      "cy": "15",
      "r": "1.5",
      "fill": "#999"
    }
  })])]), _vm._v(" "), (_vm.showMenu) ? _c('div', {
    staticClass: "menu-dropdown-content"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.showUpdateFromFirebaseModal
    }
  }, [_vm._v("Update from Archive to API")])]) : _vm._e()])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.currentChannel) ? _c('div', {
    staticClass: "channelInfo"
  }, [_c('div', [_vm._v("Channel : " + _vm._s(_vm.channel))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.currentChannel.id))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.currentChannel.pwd))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.currentChannel.desc))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticClass: "question",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "leftcolumn"
    }
  }, [_vm._v(_vm._s(_vm.todayQuestion))])]), _vm._v(" "), _c('span', {
    staticClass: "question",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "leftcolumn"
    }
  }, [_vm._v(_vm._s(_vm.race.quoteOfDay))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "flex-end",
      "gap": "15px",
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "gap": "8px",
      "padding": "6px 12px",
      "background-color": "#f8f9fa",
      "border-radius": "6px",
      "border": "1px solid #e9ecef"
    }
  }, [_c('div', {
    staticClass: "runner-filter-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.runnerIdFilter),
      expression: "runnerIdFilter"
    }],
    staticClass: "runner-filter-input",
    attrs: {
      "type": "text",
      "placeholder": "Find runner ID..."
    },
    domProps: {
      "value": (_vm.runnerIdFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.runnerIdFilter = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.runnerIdFilter) ? _c('button', {
    staticClass: "runner-filter-clear",
    attrs: {
      "type": "button",
      "title": "Clear filter"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_c('svg', {
    attrs: {
      "width": "12",
      "height": "12",
      "viewBox": "0 0 12 12",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9 3L3 9M3 3L9 9",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#dee2e6",
      "font-size": "12px"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px",
      "color": "#6c757d",
      "font-weight": "400"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#495057",
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.filteredRunnerList.length))]), _vm._v(" runners\n        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#dee2e6",
      "font-size": "12px"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px",
      "color": "#6c757d",
      "font-weight": "400"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.pageSize) + " per page\n        ")])]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "id": "changed-font",
      "width": 85,
      "height": 30,
      "speed": 480,
      "color": {
        unchecked: '#413b94',
        checked: '#ff5627'
      },
      "labels": {
        checked: 'Km',
        unchecked: 'Miles'
      }
    },
    on: {
      "change": function($event) {
        return _vm.onToggle()
      }
    },
    model: {
      value: (_vm.distanceInKm),
      callback: function($$v) {
        _vm.distanceInKm = $$v
      },
      expression: "distanceInKm"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary load_data",
    attrs: {
      "id": "downloadcsv"
    },
    on: {
      "click": function($event) {
        return _vm.downloadCSV()
      }
    }
  }, [_vm._v("Export as CSV\n      ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "min-height": "400px"
    }
  }, [(_vm.tableLoading) ? _c('loader', {
    attrs: {
      "size": 'medium',
      "full-page": false,
      "show-quote": true,
      "centered": true
    }
  }) : _vm._e(), _vm._v(" "), _c('v-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.tableLoading),
      expression: "!tableLoading"
    }],
    staticStyle: {
      "width": "100%",
      "font-size": "10.5px"
    },
    attrs: {
      "is-horizontal-resize": "",
      "columns": _vm.columnsT,
      "column-cell-class-name": _vm.columnCellClass,
      "table-data": _vm.tableDataT,
      "show-vertical-border": true,
      "odd-bg-color": '#cfe2f3',
      "title-row-height": 60,
      "row-height": 45,
      "border": 1
    },
    on: {
      "on-custom-comp": _vm.customCompFunc
    }
  })], 1), _vm._v(" "), _c('jw-pagination', {
    attrs: {
      "items": _vm.filteredRunnerList,
      "pageSize": _vm.pageSize,
      "disableDefaultStyles": true
    },
    on: {
      "changePage": _vm.onPageChange
    }
  }), _vm._v(" "), _c('lucky-live-runner', {
    attrs: {
      "details": _vm.detail,
      "show": _vm.showModal
    },
    on: {
      "saved": _vm.onSaved,
      "closed": _vm.onClosed
    }
  }), _vm._v(" "), _c('update-from-firebase-modal', {
    attrs: {
      "show": _vm.showUpdateModal,
      "raceId": _vm.raceId,
      "loading": _vm.updateLoading
    },
    on: {
      "close": _vm.closeUpdateModal,
      "confirm": _vm.handleUpdateFromFirebase
    }
  }), _vm._v(" "), _c('update-from-firebase-results-modal', {
    attrs: {
      "show": _vm.showResultsModal,
      "results": _vm.updateResults
    },
    on: {
      "close": _vm.closeResultsModal
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8a5f06a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/RaceDetail.vue
// module id = 1749
// module chunks = 2